import { cx } from './cx';

export interface BarListItem {
  label: string;
  value: number;
}

interface BarListProps {
  items: BarListItem[];
  tone?: 'teal' | 'primary';
  formatValue?: (value: number) => string;
  emptyMessage?: string;
}

/** Simple horizontal bar list — div bars, no chart library. */
export function BarList({ items, tone = 'teal', formatValue, emptyMessage }: BarListProps) {
  if (items.length === 0) {
    return <p className="rfp-muted-text">{emptyMessage ?? 'No data yet'}</p>;
  }

  const max = Math.max(...items.map((item) => item.value), 1);

  return (
    <div className="rfp-bar-list">
      {items.map((item) => (
        <div className="rfp-bar-list__row" key={item.label}>
          <span className="rfp-bar-list__label" title={item.label}>
            {item.label}
          </span>
          <span className="rfp-bar-list__track">
            <span
              className={cx(
                'rfp-bar-list__fill',
                tone === 'primary' && 'rfp-bar-list__fill--primary',
              )}
              style={{ width: `${Math.max((item.value / max) * 100, 2)}%` }}
            />
          </span>
          <span className="rfp-bar-list__value">
            {formatValue ? formatValue(item.value) : item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
